export function getColorScheme() {
	const preferredColorScheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
	if(preferredColorScheme === 'dark') {
		return 'dark';
	}
	const renderedColorScheme = getRenderedColorScheme();
    return renderedColorScheme;
}

function getRenderedColorScheme() {
	try {
		document.body.insertAdjacentHTML('beforeEnd', '<div id="detection" style="display: none; background-color: canvas; color-scheme: light"></div>');
		const bgColor = getComputedStyle(document.querySelector('#detection')).backgroundColor;
		document.querySelector('#detection').remove();
		if(bgColor !== 'rgb(255, 255, 255)') {
			return 'enforced-dark';
		} else {
			return 'light';
		}
	} catch (e) {
		return 'unknown';
	}
}
